<template>
	<div style="height: 100%; flex: 1;" class="d-flex rounded-0">

		<v-btn v-if="false && !showPagesPreview && selectedFiles.length === 0"
			style="position: absolute; top: 0; left: 0; z-index: 1000;" icon class="back-button ma-3"
			@click="$emit('back')">
			<lucide-arrow-left :size="24" style="width: 24px; height: 24px;"></lucide-arrow-left>
		</v-btn>



		 <v-btn
		style="position: absolute; top: 10px; left: 20px;"
		 class="back-button mr-2" @click="$emit('back')">
			<v-icon small class="mr-1">mdi-arrow-left</v-icon>
			<span class="font-rubik">Volver</span>
		</v-btn> 


		<div class="upload-card mx-auto d-flex flex-column rounded-0"
			:max-width="showPagesPreview || hasFiles || selectedFiles.length ? '' : maxWidth" flat
			style="max-height: 100vh; overflow-y: auto;">
			<!-- <v-card class="upload-card mx-auto shadow-lg d-flex flex-column" :max-width="showPagesPreview ? '' : maxWidth"  -->



			<div v-if="!showPagesPreview && selectedFiles.length === 0" style="max-width: 650px;"
				class="d-flex flex-column text-center align-center mx-auto pt-12">
				<h2 style="font-size: 24px;">Sube tus apuntes</h2>
				<span style="font-size: 16px;" class="my-2">Archivo PDF</span>
			</div>

			<div class="text-center d-flex flex-column align-center justify-center" style="flex: 1;">
				<div v-if="!showPagesPreview && selectedFiles.length === 0"
					class="upload-area pa-6 d-flex mt-6 flex-column justify-center align-center"
					@click="triggerFileInput" @dragover.prevent @drop.prevent="onFileDrop" style="flex: 1; width: 100%;"
					:style="`minHeight: ${minHeight}px; max-width: ${maxWidth}px`">
					<input ref="fileInput" type="file" class="d-none" @change="onFileSelected"
						accept=".pdf" />
					<v-avatar color="transparent" :size="64" class="mb-4">
						<lucide-upload-cloud color="#4dd453" :size="32" style="width: 32px;"></lucide-upload-cloud>
					</v-avatar>
					<h3 class="mb-2" style="font-weight: 500; font-size: 1rem;">Arrastra tu archivo aquí</h3>
					<p class="text-body-2 grey--text text--darken-1 mb-3">
						Archivo PDF
					</p>
					<v-btn depressed @click.stop="triggerFileInput" text style="color: #4dd453; font-size: 0.9rem;"
						class="font-rubik mt-3">
						<span>Seleccionar Archivo</span>
					</v-btn>
				</div>

				<!-- Instrucciones visuales de cómo funciona -->
				<div v-if="!showPagesPreview && selectedFiles.length === 0" 
					class="instructions-section mt-8 mb-4" style="width: 100%; max-width: 650px;">
					<h3 class="mb-6 text-center font-weight-medium" style="color: #424242; font-size: 1.1rem;">
						¿Cómo funciona?
					</h3>
					
					<div class="instructions-steps d-flex flex-column flex-md-row justify-center align-center">
						<!-- Paso 1 -->
						<div class="instruction-step d-flex flex-column align-center text-center ma-3" style="max-width: 180px;">
							<div class="step-icon mb-3 d-flex align-center justify-center" 
								style="width: 60px; height: 60px; background-color: #e8f5e8; border-radius: 50%; border: 2px solid #4dd453;">
								<lucide-upload-cloud color="#4dd453" :size="28" style="width: 28px;"></lucide-upload-cloud>
							</div>
							<div class="step-number mb-2 font-weight-bold" style="color: #4dd453; font-size: 0.9rem;">
								PASO 1
							</div>
							<h4 class="step-title mb-2" style="font-size: 0.95rem; font-weight: 600; color: #424242;">
								Sube tu archivo
							</h4>
							<p class="step-description" style="font-size: 0.85rem; color: #757575; line-height: 1.4;">
								Arrastra tu PDF o haz clic para seleccionarlo
							</p>
						</div>

						<!-- Flecha -->
						<div class="d-none d-md-flex align-center justify-center mx-2" style="color: #bdbdbd;">
							<lucide-arrow-right :size="20" style="width: 20px;"></lucide-arrow-right>
						</div>

						<!-- Paso 2 -->
						<div class="instruction-step d-flex flex-column align-center text-center ma-3" style="max-width: 180px;">
							<div class="step-icon mb-3 d-flex align-center justify-center" 
								style="width: 60px; height: 60px; background-color: #e8f5e8; border-radius: 50%; border: 2px solid #4dd453;">
								<lucide-graduation-cap color="#4dd453" :size="28" style="width: 28px;"></lucide-graduation-cap>
							</div>
							<div class="step-number mb-2 font-weight-bold" style="color: #4dd453; font-size: 0.9rem;">
								PASO 2
							</div>
							<h4 class="step-title mb-2" style="font-size: 0.95rem; font-weight: 600; color: #424242;">
								Escoge la asignatura
							</h4>
							<p class="step-description" style="font-size: 0.85rem; color: #757575; line-height: 1.4;">
								Selecciona la materia para organizar tus apuntes
							</p>
						</div>

						<!-- Flecha -->
						<div class="d-none d-md-flex align-center justify-center mx-2" style="color: #bdbdbd;">
							<lucide-arrow-right :size="20" style="width: 20px;"></lucide-arrow-right>
						</div>

						<!-- Paso 3 -->
						<div class="instruction-step d-flex flex-column align-center text-center ma-3" style="max-width: 180px;">
							<div class="step-icon mb-3 d-flex align-center justify-center" 
								style="width: 60px; height: 60px; background-color: #e8f5e8; border-radius: 50%; border: 2px solid #4dd453;">
								<lucide-globe color="#4dd453" :size="28" style="width: 28px;"></lucide-globe>
							</div>
							<div class="step-number mb-2 font-weight-bold" style="color: #4dd453; font-size: 0.9rem;">
								PASO 3
							</div>
							<h4 class="step-title mb-2" style="font-size: 0.95rem; font-weight: 600; color: #424242;">
								Elige el idioma
							</h4>
							<p class="step-description" style="font-size: 0.85rem; color: #757575; line-height: 1.4;">
								Para crear explicaciones, test y flashcards
							</p>
						</div>
					</div>

					<!-- Información adicional -->
					<div class="mt-6 text-center">
						<p style="font-size: 0.9rem; color: #757575; line-height: 1.5;">
							Generamos automáticamente <strong>explicaciones del profesor</strong>, 
							<strong>preguntas tipo test</strong>, <strong>verdadero/falso</strong> y 
							<strong>flashcards</strong> para ayudarte a estudiar
						</p>
					</div>
				</div>

				<!-- Sección de archivos recientes -->
				<div v-if="false && !showPagesPreview && selectedFiles.length === 0 && recentDocuments.length > 0"
					class="recent-documents mt-8 text-left" style="width: 100%; max-width: 650px;">
					<h3 class="mb-4 font-weight-medium">Archivos recientes</h3>
					<div class="recent-documents-scroll">
						<div class="recent-documents-grid">
							<v-hover v-for="doc in recentDocuments" :key="doc.id" v-slot="{ hover }">
								<div class="recent-document pa-3" @click="handleRecentDocumentClick(doc)">
									<div class="d-flex align-center">
										<!-- Preview de documento -->
										<div class="preview-container mr-3">
											<img v-if="doc.previewImage" :src="doc.previewImage" />
											<div v-else class="d-flex align-center justify-center">
												<lucide-file-text v-if="doc.mimeType.includes('pdf')" :size="24"
													color="#4dd453"></lucide-file-text>
												<lucide-file-text v-else-if="doc.mimeType.includes('word')" :size="24"
													color="#4285f4"></lucide-file-text>
												<lucide-image v-else :size="24" color="#9e9e9e"></lucide-image>
											</div>
										</div>
										<div class="d-flex flex-column">
											<!-- Nombre del archivo -->
											<div class="text-truncate document-name d-inline-block"
												style="max-width: 200px;">{{ doc.fileName }}</div>
											<!-- Fecha -->
											<div style="font-size: 12px; max-width: 200px;" class="grey--text">{{
												formatDate(doc.createdAt) }}</div>
										</div>
									</div>
								</div>
							</v-hover>
						</div>
					</div>
				</div>

				<!-- Vista previa de páginas de documentos -->
				<div v-if="showPagesPreview" class="pages-preview-container d-flex flex-column pt-4"
					style="width: 100%; flex: 1; height: 100%;">
					<div class="d-flex justify-space-between align-start mb-4">
						<div class="d-flex flex-column align-start pl-4 ">
							<h3 class="font-weight-bold">
								<span v-if="currentPreviewFile">
									{{ currentPreviewFile.name }}
								</span>
							</h3>

							<!-- <span :key="'totalPagesAvailable-' + refreshSelectedPages" class="grey--text"
								v-if="!isPremium">
								{{ MAX_FREE_PAGES - getTotalSelectedPages }} páginas disponibles
							</span> -->


							<div class="text-center">
								<div class="d-flex align-center justify-center mr-3">


									<v-text-field v-if="false" v-model="pageRangeInput" label="Rango de páginas"
										placeholder="ej. 1-5, 7, 9-12" @focus="handlePageRangeInputFocus"
										@input="handlePageRangeInput" hide-details outlined dense
										class="page-range-input ml-3" height="48"
										style="max-width: 300px"></v-text-field>
								</div>

								<div class="selection-info mt-2 d-flex align-center justify-start">
									<span class="font-rubik">{{ selectedPages.length }} de {{ documentPages.length }}
										páginas seleccionadas</span>

									<span v-if="!isPremium" class="grey--text ml-2"> (Máximo {{ MAX_FREE_PAGES }}
										páginas en versión
										gratuita)</span>
								</div>


							</div>
						</div>

						<div class="d-flex flex-column align-end justify-end text-end pr-3">

							<div class="px-2 mt-8 d-flex align-center"
								style="border: 1px solid #E3E5EB; border-radius: 12px; height: 46px;">


								<div @click="handleSelectAllPages" flat color="transparent"
									class="no-background-hover d-flex font-rubik pr-1 align-center cursor-pointer py-3"
									style="position: relative; cursor: pointer;">
									<div style="border: 2px solid grey; width: 20px; height: 20px; position: relative;"
										class="rounded mr-3 ml-2"
										:style="selectAllPages ? 'border: 2px solid #4DD453;  background-color: #4DD453;' : 'border: 2px solid grey'">
										<svg v-if="selectAllPages" xmlns="http://www.w3.org/2000/svg" width="24"
											height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
											stroke-linecap="round" stroke-linejoin="round"
											class="lucide lucide-check-icon lucide-check"
											style="width: 18px; height: 18px; position: absolute; left: -1px; top: -1px;">
											<path d="M20 6 9 17l-5-5" />
										</svg>
									</div>

									Seleccionar todas las páginas
								</div>

								<premium-feature v-if="showPremiumFeature" @upgrade="handleUpgrade" />

							</div>

						</div>


					</div>

					<div class="d-flex flex-column" style="flex: 1; padding-bottom: 100px;">

						<div style="flex: 1;">
							<div v-if="isProcessing"
								class="processing-overlay d-flex flex-column align-center justify-center">
								<template v-if="isUploading">
									<v-progress-circular indeterminate color="primary" size="64" width="5"
										class="mb-4"></v-progress-circular>
									<h3 class="mb-4" style="font-weight: 500; font-size: 1.2rem;">Subiendo documento...
									</h3>
									<p class="text-body-2 grey--text text--darken-1">
										Por favor, espera mientras se sube tu documento
									</p>
								</template>
								<template v-else-if="isGeneratingContent">
									<v-progress-circular indeterminate color="primary" size="64" width="5"
										class="mb-4"></v-progress-circular>
									<h3 class="mb-4" style="font-weight: 500; font-size: 1.2rem;">Generando materiales
										de estudio...</h3>
									<p class="text-body-2 grey--text text--darken-1 mt-4">
										Estamos procesando tu documento y generando materiales de estudio. Esto puede
										tardar unos segundos...
									</p>
									<!-- Componente de frases motivadoras -->
									<!-- <motivation-phrases /> --> <!-- - MotivationPhrases eliminada de aquí -->
								</template>
							</div>
							<div v-else class="pages-grid d-flex flex-wrap rounded-xl pb-12">
								<div v-for="(page, index) in documentPages" :key="index" cols="6" sm="4" md="3" lg="2"
									class="page-item pa-2" style="height: fit-content;"
									:style="$vuetify.breakpoint.smAndDown ? 'margin: auto' : ''">
									<v-card class="page-card" :class="{ 'selected': isPageSelected(index + 1) }"
										outlined @click="togglePageSelection(index + 1)">
										<div class="page-thumbnail">
											<v-img v-if="page.thumbnail" :src="page.thumbnail" contain class="white">
												<template v-slot:placeholder>
													<v-row class="fill-height ma-0" align="center" justify="center">
														<v-progress-circular indeterminate
															color="lighten-5"></v-progress-circular>
													</v-row>
												</template>
											</v-img>
											<div v-if="page.canvas" class="canvas-container white">
												<div class="canvas-wrapper" ref="canvasWrapper">
													<canvas :width="page.canvas.width" :height="page.canvas.height"
														v-bind="renderCanvas(page.canvas, index)"
														class="rounded"></canvas>
												</div>
											</div>
											<v-checkbox v-model="selectedPages" @change="toggleSelectedPages(index + 1)"
												:value="index + 1" dense hide-details class="pa-0 ma-0 preview-checkbox"
												color="primary"
												style="position: absolute; right: -6px; top: 8px;"></v-checkbox>
										</div>
									</v-card>
									<span class="mt-1 font-rubik" style="font-size: 14px;">{{ index + 1 }}</span>
								</div>
							</div>
						</div>
					</div>

					<div v-if="previewComplete" class="d-flex justify-space-between align-center mt-4"
						style="position: fixed; bottom: 0; left: 0; right: 0; background-color: white; padding: 16px; border-top: 1px solid #E3E5EB;">
						<v-btn text @click="volver">
							<lucide-arrow-left :size="16" class="mr-1"
								style="width: 16px; height: 16px;"></lucide-arrow-left>
							Volver
						</v-btn>
						<v-btn color="primary" @click="confirmPagesSelection">
							<span>Confirmar selección</span>
							<lucide-check :size="16" class="ml-1" style="width: 16px; height: 16px;"></lucide-check>
						</v-btn>
					</div>
				</div>



				<!-- Área de archivos seleccionados -->
				<v-slide-y-transition>
					<div v-if="selectedFiles.length > 0 && !showPagesPreview" class="selected-files-area py-8 mx-auto"
						style="width: 100%; max-height: calc(100vh - 72px); overflow-y: auto;">

						<div style="max-width: 650px; min-height: calc(100vh - 80px);"
							class="d-flex flex-column text-center align-center mx-auto pt-4">
							<h2 style="font-size: 24px;">Configuración del estudio</h2>
							<span style="font-size: 16px;" class="my-2">Escoje el lenguage
								<!-- , la dificultad del quiz, -->
								y los tipos de
								preguntas.</span>

							<!-- Document Preview -->
							<div v-if="selectedFiles.length > 0 && selectedFiles[0]" class="mt-4 mb-6 text-left"
								style="width: 100%; border: 1px solid #e0e0e0; border-radius: 8px; padding: 12px; max-width: 350px;">
								<div class="d-flex align-center mx-auto">
									<!-- Thumbnail or Icon -->
									<div :key="refreshThumbnail + '_preview'" class="preview-container mr-3">
										<img v-if="selectedFiles[0].thumbnail" :src="selectedFiles[0].thumbnail"
											style="width: 100%; height: 100%; object-fit: cover;" />
										<div v-else class="d-flex align-center justify-center"
											style="width: 100%; height: 100%;">
											<lucide-file-text v-if="getFileType(selectedFiles[0].name) === 'pdf'"
												:size="24" color="#dc3545"></lucide-file-text>
											<lucide-file-text v-else-if="getFileType(selectedFiles[0].name) === 'docx'"
												:size="24" color="#4285f4"></lucide-file-text>
											<lucide-image
												v-else-if="['png', 'jpg', 'jpeg'].includes(getFileType(selectedFiles[0].name))"
												:size="24" color="#9e9e9e"></lucide-image>
											<lucide-file-text v-else :size="24" color="#9e9e9e"></lucide-file-text>
											<!-- Fallback icon -->
										</div>
									</div>
									<!-- File Info -->
									<div class="d-flex flex-column" style="overflow: hidden; flex: 1;">
										<div class="text-truncate document-name" :title="selectedFiles[0].name">{{
											selectedFiles[0].name
										}}</div>
										<div style="font-size: 12px;" class="grey--text">{{
											formatFileSize(selectedFiles[0].size) }}
										</div>
									</div>
								</div>
							</div>

							<!-- Study Configurator Component -->
							<study-configurator ref="studyConfig" :is-premium="isPremium"
								:detected-language.sync="detectedLanguage" 
								:current-document-id="currentDocumentForSummary ? currentDocumentForSummary.id : null"
								@show-premium-dialog="handleUpgrade" />

						</div>




						<div class="d-flex justify-space-between align-center mt-4"
							style="position: fixed; bottom: 0; left: 0; right: 0; background-color: white; padding: 16px; border-top: 1px solid #E3E5EB;">
							<v-btn text @click="volver">
								<lucide-arrow-left :size="16" class="mr-1"
									style="width: 16px; height: 16px;"></lucide-arrow-left>
								Volver
							</v-btn>
							<v-spacer></v-spacer>

							<v-btn color="primary" class="primary" @click="goToDocumentView"
								:disabled="isUploading || !fileUploadComplete || !getConfig || getConfig.selectedSubject === null"
								:loading="isUploading">
								<span>{{ isUploading ? 'Subiendo...' : (fileUploadComplete ? 'Subir  Documento' : 'Procesar Archivo')
									}}</span>
								<lucide-arrow-right :size="16" class="ml-1"></lucide-arrow-right>
							</v-btn>
						</div>

						<!-- Estado de procesamiento para la generación final de contenido -->
						<div v-if="isProcessing && isGeneratingContent"
							class="processing-overlay-generating d-flex flex-column align-center justify-center">
							<v-progress-circular indeterminate color="primary" size="64" width="5"
								class="mb-4"></v-progress-circular>
							<h3 class="mb-4" style="font-weight: 500; font-size: 1.2rem;">Generando materiales de
								estudio...</h3>
							<p class="text-body-2 grey--text text--darken-1 mt-4">
								Estamos procesando tu documento y generando materiales de estudio. Esto puede tardar
								unos segundos...
							</p>
						</div>
					</div>
				</v-slide-y-transition>
			</div>
		</div>

		<features-dialog :showDialog.sync="showFeaturesDialog" />

		<!-- + Streaming Summary Display (ahora como overlay completo) -->
		<div v-if="currentDocumentForSummary" class="streaming-summary-wrapper">


			<div v-if="documentStructure && documentStructure.document_structure && documentStructure.document_structure.length > 0"
				class="d-flex justify-space-between align-center">
				<v-chip v-for="section in documentStructure.document_structure" :key="section.section_unique_id"
					class="ma-1 structure-chip" small outlined color="#4dd453">
					{{ section.section_name }}
				</v-chip>
			</div>

			<streaming-summary-display ref="streamingSummaryComponent" :document-id="currentDocumentForSummary.id"
				:document-name="currentDocumentForSummary.name" :language="detectedLanguage || 'auto'"
				@summary-display-error="(msg) => { $toast.error('Error en el resumen: ' + msg); }"
				@summary-display-complete="(summary) => { if (summary) $toast.success('Resumen general generado.'); }"
				@summary-display-skipped-by-user="() => { $toast.info('Resumen omitido por el usuario.'); }">
				<template v-slot:structure-chips>
					<div class="structure-chips-container pa-2">
						<div v-if="isGeneratingStructure && (!documentStructure || !documentStructure.document_structure || documentStructure.document_structure.length === 0)"
							class="text-center">
							<v-progress-circular indeterminate size="20" width="2" color="#4dd453"
								class="mr-2"></v-progress-circular>
							<span class="grey--text">Analizando la estructura del documento...</span>
						</div>
						<template
							v-else-if="documentStructure && documentStructure.document_structure && documentStructure.document_structure.length > 0">
							<v-chip v-for="section in documentStructure.document_structure"
								:key="section.section_unique_id" class="ma-1 structure-chip" small outlined
								color="#4dd453">
								{{ section.section_name }}
							</v-chip>
						</template>
						<div v-else-if="!isGeneratingStructure && structureComplete && (!documentStructure || !documentStructure.document_structure || documentStructure.document_structure.length === 0)"
							class="text-center">
							<span class="grey--text">No se pudo determinar la estructura o el documento no contiene
								secciones
								principales.</span>
						</div>
					</div>
				</template>
			</streaming-summary-display>
		</div>

		<!-- Área de configuración de estudio -->
	</div>
</template>

<script>
import {
	ArrowLeft,
	ArrowRight,
	Check,
	CheckCircle,
	FileText,
	Image,
	List,
	RotateCCW,
	Trash2,
	UploadCloud,
	X,
	GraduationCap,
	Globe
} from 'lucide-vue'
import axios from 'axios';
import * as pdfjs from 'pdfjs-dist';
import PremiumFeature from '@/components/premium/PremiumFeature.vue';
import FeaturesDialog from '@/components/premium/FeaturesDialog.vue';
import MotivationPhrases from './MotivationPhrases.vue';
import StudyConfigurator from './StudyConfigurator.vue';
import StreamingSummaryDisplay from './StreamingSummaryDisplay.vue'; // + Importar el nuevo componente

// Configurar el worker de PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default {
	name: 'FileUploader',
	components: {
		LucideUploadCloud: UploadCloud,
		LucideFileText: FileText,
		LucideImage: Image,
		RotateCCW,
		LucideX: X,
		LucideTrash2: Trash2,
		LucideCheckCircle: CheckCircle,
		LucideArrowRight: ArrowRight,
		LucideArrowLeft: ArrowLeft,
		LucideCheck: Check,
		LucideList: List,
		PremiumFeature,
		FeaturesDialog,
		MotivationPhrases,
		StudyConfigurator,
		StreamingSummaryDisplay, // + Registrar el nuevo componente
		LucideGraduationCap: GraduationCap,
		LucideGlobe: Globe
	},
	props: {
		autoSelectingDocument: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: [Number, String],
			default: 650
		},
		minHeight: {
			type: [Number, String],
			default: 400
		},
		hasFiles: {
			type: Boolean
		},
		subjectId: {
			type: [Number, String],
			default: null
		}
	},
	mounted() {
		this.loadRecentDocuments();
	},
	data: () => ({
		selectedFiles: [],
		isProcessing: false,
		isUploading: false,
		previewComplete: false,
		processingComplete: false,
		uploadError: null,
		showPagesPreview: false,
		refreshSelectedPages: 0,
		currentPreviewFile: null,
		currentPreviewIndex: 0,
		documentPages: [],
		selectedPages: [],
		isLoadingPages: false,
		selectAllPages: false,
		pageRangeInput: '',
		filesWithSelectedPages: {},
		fileThumbnails: {},
		MAX_FREE_PAGES: 10,
		showFeaturesDialog: false,
		remainingPages: 10,
		// showMotivationDialog: false, // - Eliminar si no se usa más
		// motivationPhrases: [], // - Eliminar
		// currentMotivationPhrase: { frase: "", autor: "" }, // - Eliminar
		// motivationInterval: null, // - Eliminar
		// processingStepText: "Subiendo documento...", // - Eliminar
		isGeneratingContent: false,
		fileUploadComplete: false,
		recentDocuments: [],
		selectedLanguage: 'auto',
		selectedQuestionTypes: ['multiple_choice', 'true_false'],
		questionTypes: [
			{
				name: 'Opción Múltiple',
				value: 'multiple_choice',
				description: 'Preguntas con varias opciones de respuesta',
				isPremiumType: false
			},
			{
				name: 'Verdadero o Falso',
				value: 'true_false',
				description: 'Preguntas de verdadero o falso',
				isPremiumType: false
			},
			{
				name: 'Respuesta Corta',
				value: 'short_answer',
				description: 'Preguntas que requieren una respuesta breve',
				isPremiumType: true
			},
			{
				name: 'Completar Espacios',
				value: 'fill_in_the_blank',
				description: 'Completa los espacios en blanco',
				isPremiumType: true
			},
			{
				name: 'Emparejamiento',
				value: 'matching_pairs',
				description: 'Relaciona elementos de dos columnas',
				isPremiumType: true
			},
			{
				name: 'Ordenamiento',
				value: 'ordering',
				description: 'Ordena elementos en la secuencia correcta',
				isPremiumType: true
			}
		],
		languages: [
			// Original + Actualitzats
			{
				name: 'Automático',
				code: 'auto',
				bandera: require('@/assets/flags/auto.svg')
			},
			// --- Idiomas de España ---
			{
				name: 'Español',
				code: 'spa',
				bandera: require('@/assets/flags/ES.svg')
			},
			{
				name: 'Catalán',
				code: 'cat',
				bandera: require('@/assets/flags/catalonia.svg') // Canviat a Andorra segons disponibilitat
			},
			{
				name: 'Gallego',
				code: 'glg',
				bandera: require('@/assets/flags/galicia.svg') // Mantingut regional
			},
			{
				name: 'Euskera',
				code: 'eu', // Mantingut codi original (no 'eus' a la llista de codis)
				bandera: require('@/assets/flags/basque.svg') // Mantingut regional
			},
			// --- Idiomas Europeos Principales ---
			{
				name: 'Inglés',
				code: 'eng',
				bandera: require('@/assets/flags/GB.svg') // Canviat a GB per coherència (US també disponible)
			},
			{
				name: 'Francés',
				code: 'fra',
				bandera: require('@/assets/flags/FR.svg')
			},
			{
				name: 'Portugués',
				code: 'por',
				bandera: require('@/assets/flags/PT.svg') // Canviat a PT per origen (BR també disponible)
			},
			{
				name: 'Italiano',
				code: 'ita',
				bandera: require('@/assets/flags/IT.svg')
			},
			{
				name: 'Alemán',
				code: 'deu',
				bandera: require('@/assets/flags/DE.svg')
			},
			{
				name: 'Holandés',
				code: 'nld',
				bandera: require('@/assets/flags/NL.svg')
			},
			// --- Idiomas Eslavos ---
			{
				name: 'Ruso',
				code: 'rus',
				bandera: require('@/assets/flags/RU.svg')
			},
			{
				name: 'Polaco',
				code: 'pol',
				bandera: require('@/assets/flags/PL.svg')
			},
			{
				name: 'Ucraniano',
				code: 'ukr',
				bandera: require('@/assets/flags/UA.svg')
			},
			{
				name: 'Checo',
				code: 'ces',
				bandera: require('@/assets/flags/CZ.svg')
			},
			{
				name: 'Eslovaco', // Afegit
				code: 'slk',
				bandera: require('@/assets/flags/SK.svg')
			},
			{
				name: 'Búlgaro',
				code: 'bul',
				bandera: require('@/assets/flags/BG.svg')
			},
			{
				name: 'Serbio', // Afegit
				code: 'srp',
				bandera: require('@/assets/flags/RS.svg')
			},
			{
				name: 'Croata', // Afegit
				code: 'hrv',
				bandera: require('@/assets/flags/HR.svg')
			},
			{
				name: 'Bosnio', // Afegit
				code: 'bos',
				bandera: require('@/assets/flags/BA.svg')
			},
			{
				name: 'Esloveno', // Afegit
				code: 'slv',
				bandera: require('@/assets/flags/SI.svg')
			},
			{
				name: 'Bielorruso', // Afegit
				code: 'bel',
				bandera: require('@/assets/flags/BY.svg')
			},
			{
				name: 'Macedonio', // Afegit
				code: 'mkd',
				bandera: require('@/assets/flags/MK.svg')
			},
			// --- Idiomas Nórdicos ---
			{
				name: 'Sueco',
				code: 'swe',
				bandera: require('@/assets/flags/SE.svg')
			},
			{
				name: 'Danés',
				code: 'dan',
				bandera: require('@/assets/flags/DK.svg')
			},
			{
				name: 'Noruego (Bokmål)',
				code: 'nob',
				bandera: require('@/assets/flags/NO.svg')
			},
			{
				name: 'Finlandés',
				code: 'fin',
				bandera: require('@/assets/flags/FI.svg')
			},
			// --- Otros Idiomas Europeos ---
			{
				name: 'Griego (Moderno)',
				code: 'ell',
				bandera: require('@/assets/flags/GR.svg')
			},
			{
				name: 'Húngaro',
				code: 'hun',
				bandera: require('@/assets/flags/HU.svg')
			},
			{
				name: 'Rumano',
				code: 'ron',
				bandera: require('@/assets/flags/RO.svg')
			},
			{
				name: 'Albanés', // Afegit (Tosk)
				code: 'als',
				bandera: require('@/assets/flags/AL.svg')
			},
			{
				name: 'Lituano', // Afegit
				code: 'lit',
				bandera: require('@/assets/flags/LT.svg')
			},
			{
				name: 'Letón', // Afegit
				code: 'lvs',
				bandera: require('@/assets/flags/LV.svg')
			},
			{
				name: 'Estonio', // Afegit
				code: 'ekk',
				bandera: require('@/assets/flags/EE.svg')
			},
			// --- Idiomas Asiáticos (Este) ---
			{
				name: 'Chino (Mandarín)',
				code: 'cmn',
				bandera: require('@/assets/flags/CN.svg')
			},
			{
				name: 'Japonés',
				code: 'jpn',
				bandera: require('@/assets/flags/JP.svg')
			},
			{
				name: 'Coreano',
				code: 'kor',
				bandera: require('@/assets/flags/KR.svg')
			},
			{
				name: 'Vietnamita',
				code: 'vie',
				bandera: require('@/assets/flags/VN.svg')
			},
			{
				name: 'Tailandés',
				code: 'tha',
				bandera: require('@/assets/flags/TH.svg')
			},
			{
				name: 'Birmano', // Afegit
				code: 'mya',
				bandera: require('@/assets/flags/MM.svg')
			},
			{
				name: 'Jemer', // Afegit
				code: 'khm',
				bandera: require('@/assets/flags/KH.svg')
			},
			{
				name: 'Laosiano', // Afegit
				code: 'lao',
				bandera: require('@/assets/flags/LA.svg')
			},
			// --- Idiomas Asiáticos (Sur) ---
			{
				name: 'Hindi',
				code: 'hin',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Bengalí',
				code: 'ben',
				bandera: require('@/assets/flags/BD.svg') // Bangladesh (IN també disponible)
			},
			{
				name: 'Urdu',
				code: 'urd',
				bandera: require('@/assets/flags/PK.svg') // Pakistan (IN també disponible)
			},
			{
				name: 'Panyabí', // Afegit
				code: 'pan',
				bandera: require('@/assets/flags/IN.svg') // India (PK també disponible)
			},
			{
				name: 'Telugú', // Afegit
				code: 'tel',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Maratí', // Afegit
				code: 'mar',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Tamil', // Afegit
				code: 'tam',
				bandera: require('@/assets/flags/IN.svg') // India (LK també disponible)
			},
			{
				name: 'Guyaratí', // Afegit
				code: 'guj',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Canarés', // Afegit
				code: 'kan',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Malabar', // Afegit (Malayalam)
				code: 'mal',
				bandera: require('@/assets/flags/IN.svg')
			},
			{
				name: 'Nepalí', // Afegit
				code: 'npi',
				bandera: require('@/assets/flags/NP.svg')
			},
			{
				name: 'Cingalés', // Afegit
				code: 'sin',
				bandera: require('@/assets/flags/LK.svg')
			},
			// --- Idiomas Asiáticos (Sudeste Insular) ---
			{
				name: 'Indonesio',
				code: 'ind',
				bandera: require('@/assets/flags/ID.svg')
			},
			{
				name: 'Malayo',
				code: 'zlm',
				bandera: require('@/assets/flags/MY.svg') // Malasia (ID, BN, SG també rellevants)
			},
			{
				name: 'Javanés', // Afegit
				code: 'jav',
				bandera: require('@/assets/flags/ID.svg')
			},
			{
				name: 'Sundanés', // Afegit
				code: 'sun',
				bandera: require('@/assets/flags/ID.svg')
			},
			{
				name: 'Tagalo', // Afegit
				code: 'tgl',
				bandera: require('@/assets/flags/PH.svg')
			},
			// --- Idiomas de Oriente Medio y Asia Central ---
			{
				name: 'Árabe (Estándar)',
				code: 'arb',
				bandera: require('@/assets/flags/SA.svg') // Arabia Saudí (representativa, molts països)
			},
			{
				name: 'Turco',
				code: 'tur',
				bandera: require('@/assets/flags/TR.svg')
			},
			{
				name: 'Persa (Iraní)',
				code: 'pes',
				bandera: require('@/assets/flags/IR.svg')
			},
			{
				name: 'Dari (Persa Afgano)', // Afegit
				code: 'prs',
				bandera: require('@/assets/flags/AF.svg')
			},
			{
				name: 'Hebreo',
				code: 'heb',
				bandera: require('@/assets/flags/IL.svg')
			},
			{
				name: 'Azerí', // Afegit
				code: 'azj',
				bandera: require('@/assets/flags/AZ.svg')
			},
			{
				name: 'Uzbeco', // Afegit
				code: 'uzn',
				bandera: require('@/assets/flags/UZ.svg')
			},
			{
				name: 'Kazajo', // Afegit
				code: 'kaz',
				bandera: require('@/assets/flags/KZ.svg')
			},
			{
				name: 'Turcomano', // Afegit
				code: 'tuk',
				bandera: require('@/assets/flags/TM.svg')
			},
			{
				name: 'Kirguís', // Afegit
				code: 'kir',
				bandera: require('@/assets/flags/KG.svg')
			},
			{
				name: 'Tayiko', // Afegit
				code: 'tgk',
				bandera: require('@/assets/flags/TJ.svg')
			},
			{
				name: 'Armenio', // Afegit
				code: 'hye',
				bandera: require('@/assets/flags/AM.svg')
			},
			{
				name: 'Georgiano', // Afegit
				code: 'kat',
				bandera: require('@/assets/flags/GE.svg')
			},
			// --- Idiomas Africanos ---
			{
				name: 'Suajili', // Afegit
				code: 'swh',
				bandera: require('@/assets/flags/KE.svg') // Kenia (TZ, UG també rellevants)
			},
			{
				name: 'Hausa', // Afegit
				code: 'hau',
				bandera: require('@/assets/flags/NG.svg') // Nigeria (NE també rellevant)
			},
			{
				name: 'Amárico', // Afegit
				code: 'amh',
				bandera: require('@/assets/flags/ET.svg')
			},
			{
				name: 'Yoruba', // Afegit
				code: 'yor',
				bandera: require('@/assets/flags/NG.svg') // Nigeria (BJ també rellevant)
			},
			{
				name: 'Igbo', // Afegit
				code: 'ibo',
				bandera: require('@/assets/flags/NG.svg')
			},
			{
				name: 'Zulú', // Afegit
				code: 'zul',
				bandera: require('@/assets/flags/ZA.svg')
			},
			{
				name: 'Xhosa', // Afegit
				code: 'xho',
				bandera: require('@/assets/flags/ZA.svg')
			},
			{
				name: 'Afrikáans', // Afegit
				code: 'afr',
				bandera: require('@/assets/flags/ZA.svg') // Sudáfrica (NA també rellevant)
			},
			{
				name: 'Somalí', // Afegit
				code: 'som',
				bandera: require('@/assets/flags/SO.svg')
			},
			{
				name: 'Shona', // Afegit
				code: 'sna',
				bandera: require('@/assets/flags/ZW.svg')
			},
			{
				name: 'Wólof', // Afegit
				code: 'wol',
				bandera: require('@/assets/flags/SN.svg')
			},
			// --- Idiomas Americanos (Nativos/Criollos) ---
			{
				name: 'Criollo Haitiano', // Afegit
				code: 'hat',
				bandera: require('@/assets/flags/HT.svg')
			},
			// ... (Podrían añadirse Quechua, Guaraní, etc., si hubiera códigos y banderas representativas disponibles)

			// --- Otros (Esperanto, etc.) ---
			{
				name: 'Esperanto', // Afegit
				code: 'epo',
				bandera: require('@/assets/flags/AQ.svg') // Bandera Antártida (Símbolo Neutral / Placeholder)
			}
		],
		detectedLanguage: 'auto',
		selectedSubject: null,
		subjects: [],
		refreshThumbnail: 0,

		// + Nuevas propiedades para el resumen en streaming
		showStreamingSummary: false,
		currentDocumentForSummary: null,
		isProcessingSummary: false, // + Nuevo estado para el procesamiento del resumen
		// summaryPromise: null, // - Ya no es necesario con la llamada directa al método del hijo

		// + Nueva propiedad para la estructura del documento
		documentStructure: null,
		isGeneratingStructure: false,
		structureComplete: false,
	}),
	computed: {
		isPremium() {
			return this.$root.currentUser && this.$root.currentUser.premium;
		},
		showPremiumFeature() {
			return !this.isPremium && this.documentPages.length > this.MAX_FREE_PAGES;
		},
		totalSelectedPages() {
			if (this.selectedFiles.length === 0) return 0;

			const file = this.selectedFiles[0];
			if (this.filesWithSelectedPages[file.name]) {
				return this.filesWithSelectedPages[file.name].length;
			} else {
				return file.pages || 0;
			}
		},
		fileSelectedPages() {
			return (file) => {
				if (this.filesWithSelectedPages[file.name]) {
					return this.filesWithSelectedPages[file.name].length;
				}
				return 0;
			};
		},
		getTotalSelectedPagesExcludingCurrent() {
			return 0; // Ya no es necesario con un solo archivo
		},
		getTotalSelectedPages() {
			return this.selectedPages.length;
		},
		getConfig() {
			return this.$refs.studyConfig.getConfig();
		},
	},
	methods: {
		handleUpgrade(eventData = null) {
			// Si se recibe un objeto con premium_from del StudyConfigurator, usarlo
			// Si no, usar el valor por defecto para el FileUploader
			const premiumFrom = eventData?.premium_from || 'file_uploader_premium_cta';
			this.openFeaturesDialog(premiumFrom);
		},
		toggleSelectedPages(index) {
			if (this.selectedPages.includes(index)) {
				this.selectedPages = this.selectedPages.filter(p => p != index)
			} else {
				this.selectedPages.push(index)
			}
		},
		triggerFileInput() {
			this.$refs.fileInput.click();
		},
		onFileDrop(event) {
			event.preventDefault();
			this.onFileSelected(event.dataTransfer.files);
		},
		async onFileSelected(event) {
			console.log('onFileSelected llamado', event);
			const files = event.target ? event.target.files : event;

			if (files && files.length > 0) {
				// Limpiar archivos anteriores
				this.selectedFiles = [];
				this.filesWithSelectedPages = {};
				this.fileUploadComplete = false;

				this.$emit("update:hasFiles", true);

				// Set selected file (solo el primer archivo)
				let file;
				if (files.item) {
					// Si es un FileList
					file = files[0];
				} else if (Array.isArray(files)) {
					// Si es un array
					file = files[0];
				} else {
					// Si es un solo archivo
					file = files;
				}

				// Comprobar tamaño máximo (50 MB)
				const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB en bytes
				if (file.size > MAX_FILE_SIZE) {
					this.$toast.error('El archivo es demasiado grande. El tamaño máximo permitido es de 50 MB.');
					return;
				}

				const fileType = this.getFileType(file.name);
				
				// Comprobar si el archivo es PDF
				if (fileType !== 'pdf') {
					this.$toast.error('Solo se permiten archivos PDF por ahora.');
					return;
				}

				// Añadir el archivo a selectedFiles inmediatamente
				this.selectedFiles.push(file);

				// Obtener configuración de anonimato
				let anonymous = false;
				if (this.$refs.studyConfig && this.$refs.studyConfig.getConfig) {
					const config = this.$refs.studyConfig.getConfig();
					anonymous = config.anonymous;
				}

				// Subir el documento directamente sin mostrar la vista previa
				await this.uploadDocument(file, anonymous);

				// Asegurar que no se muestre la vista previa de páginas
				this.showPagesPreview = false;

				if (fileType === 'pdf') {
					try {
						// Convertir File a ArrayBuffer
						if (file.arrayBuffer) {
							const arrayBuffer = await file.arrayBuffer();
							const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;
							file.pages = pdf.numPages;

							// Generar thumbnail para la primera página
							const height = 330;
							const page = await pdf.getPage(1);
							const scale = height / page.view[2];
							const viewport = page.getViewport({ scale });
							const canvas = document.createElement('canvas');
							const context = canvas.getContext('2d');
							canvas.height = viewport.height;
							canvas.width = viewport.width;

							await page.render({
								canvasContext: context,
								viewport: viewport
							}).promise;

							file.thumbnail = canvas.toDataURL('image/jpeg', 0.9);
							console.log('file.thumbnail', file.thumbnail)
							this.refreshThumbnail++;

							await this.axios.post('/update-thumbnail', {
								documentId: file.documentId,
								preview_image: file.thumbnail,
								userId: this.$root.currentUser.userId,
								num_pages: file.pages
							}, {
								headers: { "Authorization": this.$root.token.value }
							});
						}

						// Procesar el PDF de forma asíncrona
						// this.processFile(file, getArrayBuffer);
					} catch (error) {
						console.error('Error al procesar el PDF:', error);
						file.pages = 0;
					}
				}
			}

			// Emitir evento con el archivo seleccionado
			this.$emit('files-updated', this.selectedFiles);
			this.$emit('disable-auto-selecting-document');
		},
		getLanguageName(code) {
			const language = this.languages.find(l => l.code === code);
			return language ? language.name : 'Idioma no disponible';
		},
		async processFiles() {
			this.isProcessing = true; // Estado general de procesamiento activado
			this.uploadError = null;
			let overallSummaryText = null; // Para almacenar el resumen obtenido
			let documentStructure = null; // Para almacenar la estructura
			this.documentStructure = null; // Resetear estructura en el componente

			try {
				// Paso 1: Generar en paralelo el resumen en streaming y la estructura del documento
				if (this.currentDocumentForSummary && this.currentDocumentForSummary.id) {
					console.log("FileUploader: Iniciando generación de resumen y estructura en paralelo...");
					this.isProcessingSummary = true;
					this.isGeneratingStructure = true;
					this.showStreamingSummary = true;

					await this.$nextTick(); // Esperar que el componente se monte/actualice

					// Por ahora no generamos el resumen en streaming
					// Iniciar ambas solicitudes en paralelo
					// const summaryPromise = this.$refs.streamingSummaryComponent 
					// 	? this.$refs.streamingSummaryComponent.fetchStreamingSummary() 
					// 	: Promise.resolve(null);

					const structurePromise = this.fetchStreamingDocumentStructure();

					// Esperar a que ambas terminen
					[overallSummaryText, documentStructure] = await Promise.all([
						// summaryPromise,
						structurePromise
					]);

					console.log("FileUploader: Resumen y estructura generados en paralelo.");
					this.isProcessingSummary = false;
					this.isGeneratingStructure = false;
					this.documentStructure = documentStructure; // Actualizar estructura en el componente

					// No ocultamos el streaming summary hasta que el usuario confirme o descarte
				} else {
					this.$toast.info("No hay documento seleccionado para generar contenido. Saltando este paso.")
				}

				const file = this.selectedFiles[0];
				if (!file || !file.documentId) {
					this.$toast.error('Error: No hay archivo seleccionado o falta el ID del documento para generar contenido.');
					this.isProcessing = false;
					return;
				}
				const documentId = file.documentId;

				return

				console.log("FileUploader: Iniciando generación de contenido completo...");
				this.isGeneratingContent = true;
				try {
					const config = this.$refs.studyConfig.getConfig();
					const languageName = config.selectedLanguage === 'auto' ? 'auto' : this.getLanguageName(config.selectedLanguage);

					const requestBody = {
						documentId,
						user_id: this.$root.currentUser.userId,
						contentTypes: ['flashcards', 'quiz', 'summary'],
						language: languageName,
						questionTypes: config.selectedQuestionTypes
					};

					if (overallSummaryText && overallSummaryText.trim() !== "") {
						requestBody.overallSummary = overallSummaryText;
						console.log("FileUploader: Enviando resumen general al backend.");
					} else {
						console.log("FileUploader: No hay resumen general para enviar o está vacío.");
					}

					// Incluir estructura para generación de contenido si está disponible
					if (this.documentStructure) {
						requestBody.documentStructure = this.documentStructure;
						console.log("FileUploader: Enviando estructura del documento al backend:",
							this.documentStructure.document_structure?.length || 0, "secciones principales");
					} else {
						console.log("FileUploader: No hay estructura disponible para enviar.");
					}

					const contentResponse = await axios.post('/generate-all-content', requestBody, {
						headers: { "Authorization": this.$root.token.value }
					});

					if (contentResponse.data.success) {
						if (config.selectedSubject) {
							await this.$refs.studyConfig.assignDocumentToSubject(documentId);
						}
						this.$emit('document-uploaded', {
							documentId,
							fileName: file.name,
							...contentResponse.data
						});
						this.$router.push(`/app/document/${documentId}?language=${languageName}`);
					} else {
						this.$toast.warning('El documento se procesó, pero hubo un problema al generar el contenido adicional.');
						this.$emit('document-uploaded', {
							documentId,
							fileName: file.name,
							generationError: true
						});
					}
				} catch (generationError) {
					console.error('Error generando contenido completo:', generationError);
					this.$toast.error('Error al generar el contenido completo. Puedes intentar generarlo más tarde desde la vista del documento.');
					this.$emit('document-uploaded', { documentId, fileName: file.name, generationError: true });
				} finally {
					this.isGeneratingContent = false;
				}

				this.processingComplete = true;
				setTimeout(() => {
					this.processingComplete = false;
				}, 3000);

			} catch (error) {
				console.error('Error en processFiles:', error);
				this.uploadError = 'Error al procesar los archivos. Por favor, inténtalo de nuevo.';
				this.$toast.error(this.uploadError);
			} finally {
				this.isProcessing = false;
				this.isProcessingSummary = false;
				this.isGeneratingStructure = false;
				this.isGeneratingContent = false;
			}
		},
		getFileType(filename) {
			return filename.split('.').pop().toLowerCase();
		},
		formatFileSize(size) {
			if (size < 1024) return size + ' bytes';
			if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB';
			if (size < 1024 * 1024 * 1024) return (size / (1024 * 1024)).toFixed(2) + ' MB';
			return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
		},
		async showPagePreview(file) {
			// Asegurarse de que filesWithSelectedPages esté inicializado
			if (!this.filesWithSelectedPages) {
				this.filesWithSelectedPages = {};
			}

			this.showPagesPreview = true;
			this.currentPreviewFile = file;
			this.documentPages = [];

			try {
				// Cargar PDF y generar miniaturas
				if (this.getFileType(file.name) === 'pdf') {
					await this.loadPdfPages(file);
				}
			} catch (error) {
				console.error('Error al cargar la vista previa del PDF:', error);
			}
		},
		async loadPdfPages(file) {
			try {
				let pdfData;

				if (file.documentId) {
					// Si es un documento reciente, obtener el PDF del servidor
					const response = await axios.get(`/document/${file.documentId}/content`, {
						headers: { "Authorization": this.$root.token.value },
						responseType: 'arraybuffer'
					});
					pdfData = response.data;
				} else {
					// Si es un archivo nuevo, usar arrayBuffer
					pdfData = await file.arrayBuffer();
				}

				// Cargar PDF
				const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
				const numPages = pdf.numPages;

				// Establecer páginas seleccionadas desde el principio
				if (this.filesWithSelectedPages[file.name]) {
					this.selectedPages = [...this.filesWithSelectedPages[file.name]];
				} else if (!this.isPremium) {
					// Calcular cuántas páginas podemos seleccionar basándonos en el límite gratuito
					const availablePages = Math.min(numPages, this.MAX_FREE_PAGES);
					this.selectedPages = Array.from({ length: availablePages }, (_, i) => i + 1);
				} else {
					// If is premium, select all pages
					this.selectedPages = Array.from({ length: numPages }, (_, i) => i + 1);
				}

				// First create all pages as blank
				this.documentPages = Array.from({ length: numPages }, (_, i) => ({
					pageNumber: i + 1,
					canvas: null
				}));

				this.previewComplete = true;
				this.refreshSelectedPages++;

				// Create array of promises to render all pages in parallel
				const renderPromises = Array.from({ length: numPages }, async (_, i) => {
					const page = await pdf.getPage(i + 1);
					const scale = 150 / page.view[2];
					const viewport = page.getViewport({ scale });
					const canvas = document.createElement('canvas');
					const context = canvas.getContext('2d');
					canvas.height = viewport.height;
					canvas.width = viewport.width;

					await page.render({
						canvasContext: context,
						viewport: viewport
					}).promise;

					// Guardar el thumbnail si es la primera página y no tenemos ya uno
					if (i === 0 && !file.thumbnail) {
						file.thumbnail = canvas.toDataURL('image/jpeg', 0.9);
						// Subir el archivo en segundo plano
						// this.uploadDocument(file);
					}

					// Update canvas as soon as it is available
					if (i < this.documentPages.length)
						this.documentPages[i].canvas = canvas;
				});

				// Execute all promises in parallel
				await Promise.all(renderPromises);

			} catch (error) {
				console.error('Error generating PDF thumbnails:', error);
				throw error;
			}
		},
		closePreview() {
			// Clear all data related to the preview
			this.showPagesPreview = false;
			this.currentPreviewFile = null;
			this.documentPages = [];
			this.selectedPages = [];
			this.filesWithSelectedPages = {};
			this.selectAllPages = false;
			this.pageRangeInput = '';
			this.previewComplete = false;
		},
		togglePageSelection(pageNumber) {
			if (!this.isPremium) {
				const totalSelectedPages = this.getTotalSelectedPagesExcludingCurrent + this.selectedPages.length;
				const isPageSelected = this.selectedPages.includes(pageNumber);

				// If the page is not selected and we've already reached the limit
				if (!isPageSelected && totalSelectedPages >= this.MAX_FREE_PAGES) {
					this.openFeaturesDialog('file_uploader_page_limit_exceeded');
					return;
				}
			}

			const index = this.selectedPages.indexOf(pageNumber);
			if (index === -1) {
				this.selectedPages.push(pageNumber);
			} else {
				this.selectedPages.splice(index, 1);
			}
		},
		isPageSelected(pageNumber) {
			return this.selectedPages.includes(pageNumber);
		},
		handleSelectAllPages(value) {
			if (this.selectAllPages) {
				this.selectedPages = []
				this.selectAllPages = false
				return
			}

			if (!this.isPremium) {
				// Check the total number of available pages considering other files
				const pagesSelectedInOtherFiles = this.getTotalSelectedPagesExcludingCurrent;
				const pagesAvailable = Math.max(0, this.MAX_FREE_PAGES - pagesSelectedInOtherFiles);

				// If the current document's pages exceed the available pages, show premium dialog
				if (this.documentPages.length > pagesAvailable) {
					this.openFeaturesDialog('file_uploader_select_all_premium');
					this.selectAllPages = false;
					return;
				}
			}

			if (value) {
				this.selectedPages = Array.from({ length: this.documentPages.length }, (_, i) => i + 1);
				this.pageRangeInput = '';
			} else {
				this.selectedPages = [];
			}

			this.selectAllPages = true;
		},
		handlePageRangeInputFocus(value) {
			console.log("handlePageRangeInputFocus", value)

			// Si no es premium, calcular cuántas páginas ya están seleccionadas en otros archivos
			let pagesAvailable = this.MAX_FREE_PAGES;
			if (!this.isPremium) {
				this.openFeaturesDialog('file_uploader_page_range_limit');
			}

		},
		handlePageRangeInput(value) {
			if (!value) {
				this.selectedPages = [];
				return;
			}

			const newSelectedPages = new Set();
			const ranges = value.split(',').map(r => r.trim());

			// Si no es premium, calcular cuántas páginas ya están seleccionadas en otros archivos
			let pagesAvailable = this.MAX_FREE_PAGES;
			if (!this.isPremium) {
				const pagesSelectedInOtherFiles = this.getTotalSelectedPagesExcludingCurrent;
				pagesAvailable = Math.max(0, this.MAX_FREE_PAGES - pagesSelectedInOtherFiles);
			}

			ranges.forEach(range => {
				if (range.includes('-')) {
					const [start, end] = range.split('-').map(Number);
					if (!isNaN(start) && !isNaN(end) && start <= end) {
						for (let i = start; i <= end; i++) {
							if (!this.isPremium && newSelectedPages.size >= pagesAvailable) {
								this.openFeaturesDialog('file_uploader_page_range_limit_exceeded');
								return;
							}
							newSelectedPages.add(i);
						}
					}
				} else {
					const pageNum = Number(range);
					if (!isNaN(pageNum) && pageNum > 0 && pageNum <= this.documentPages.length) {
						if (!this.isPremium && newSelectedPages.size >= pagesAvailable) {
							this.openFeaturesDialog('file_uploader_page_range_limit_exceeded');
							return;
						}
						newSelectedPages.add(pageNum);
					}
				}
			});

			this.selectedPages = Array.from(newSelectedPages).sort((a, b) => a - b);
		},
		confirmPagesSelection() {
			if (!this.filesWithSelectedPages)
				this.filesWithSelectedPages = {}

			if (this.currentPreviewFile) {
				// Guardar selección de páginas
				this.filesWithSelectedPages[this.currentPreviewFile.name] = [...this.selectedPages];
			}

			this.closePreview();
		},
		clearFiles() {
			this.selectedFiles = [];
			this.filesWithSelectedPages = {};
			this.$emit('files-updated', this.selectedFiles);
		},
		volver() {
			this.clearFiles();
			this.closePreview();
			// + Resetear estados del resumen en streaming al volver
			this.showStreamingSummary = false;
			this.currentDocumentForSummary = null;
			this.fileUploadComplete = false; // Asegurar que el estado de subida se reinicie también
			this.isUploading = false;
			this.isGeneratingContent = false;
			this.isProcessing = false; // Reinicia el estado general de procesamiento
		},
		renderCanvas(sourceCanvas, index) {
			this.$nextTick(() => {
				const canvasElements = this.$refs.canvasWrapper;
				if (canvasElements && canvasElements[index]) {
					const targetCanvas = canvasElements[index].querySelector('canvas');
					if (targetCanvas) {
						const context = targetCanvas.getContext('2d');
						context.drawImage(sourceCanvas, 0, 0);
					}
				}
			});
			return {};
		},
		// Nuevos métodos para las frases motivadoras
		initMotivationPhrases() {
			// Obtener las frases del componente MotivationPhrases
			const motivationComponent = new MotivationPhrases();
			this.motivationPhrases = motivationComponent.$data.motivationPhrases;

			// Seleccionar una frase aleatoria inicial
			this.selectRandomPhrase();

			// Cambiar la frase cada 8 segundos
			this.motivationInterval = setInterval(() => {
				this.selectRandomPhrase();
			}, 8000);
		},

		selectRandomPhrase() {
			const randomIndex = Math.floor(Math.random() * this.motivationPhrases.length);
			this.currentMotivationPhrase = this.motivationPhrases[randomIndex];
		},

		clearMotivationInterval() {
			if (this.motivationInterval) {
				clearInterval(this.motivationInterval);
				this.motivationInterval = null;
			}
		},
		// Nueva función para subir el documento al backend
		async uploadDocument(file, anonymous = false) {
			this.isUploading = true;
			// this.isProcessing = true; // - Ya no se establece aquí
			this.fileUploadComplete = false;
			this.showStreamingSummary = false;
			this.currentDocumentForSummary = null;

			const community_id = this.$root.currentUser?.educationInfo?.education?.community_id || 2027;

			try {
				const formData = new FormData();
				formData.append('file', file);
				if (file.thumbnail) {
					formData.append('preview_image', file.thumbnail);
				}
				formData.append('user_id', this.$root.currentUser.userId);
				formData.append('num_pages', file.pages || 0); // Usar file.pages o 0
				formData.append('community_id', community_id);

				// Añadir subject_id si está disponible
				if (this.subjectId) {
					formData.append('subject_id', this.subjectId);
					console.log('Enviando con subject_id:', this.subjectId);
				}

				// Añadir anonymous si está marcado
				formData.append('anonymous', anonymous ? 1 : 0);

				const response = await axios.post('/upload-document', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						"Authorization": this.$root.token.value
					}
				});

				if (response.data.success) {
					file.documentId = response.data.documentId;
					this.detectedLanguage = response.data.language;

					// + Guardar datos para el resumen, pero no mostrarlo todavía
					this.currentDocumentForSummary = { id: file.documentId, name: file.name, pages: file.pages || 0 };
					// this.showStreamingSummary = true; // - No se muestra aquí
					this.fileUploadComplete = true; // Indicar que la subida está lista para la configuración

				} else {
					this.$toast.error('Error al subir el archivo: ' + (response.data.error || ''));
					this.removeFile(0);
				}
			} catch (error) {
				console.error('Error al subir el archivo:', error);
				this.$toast.error('Error catastrófico al subir el archivo.');
				this.removeFile(0);
			} finally {
				this.isUploading = false; // La subida (uploading) ha terminado aquí
			}
		},
		async loadRecentDocuments() {
			try {
				const response = await axios.get('/recent-documents', {
					headers: { "Authorization": this.$root.token.value }
				});
				if (response.data.success) {
					this.recentDocuments = response.data.documents;
				}
			} catch (error) {
				console.error('Error al cargar documentos recientes:', error);
			}
		},

		formatDate(date) {
			return new Date(date).toLocaleDateString('es-ES', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			});
		},

		async handleRecentDocumentClick(doc) {
			try {
				// Obtener el documento completo
				const response = await axios.get(`/document/${doc.id}`, {
					headers: { "Authorization": this.$root.token.value }
				});

				if (response.data.success) {
					const documentData = response.data.document;

					// Crear un objeto File simulado con la información del documento
					const file = {
						name: documentData.fileName,
						documentId: doc.id,
						size: documentData.size,
						type: documentData.mime_type,
						pages: documentData.selectedPages ? documentData.selectedPages.length : 1,
						thumbnail: doc.previewImage
					};

					// Limpiar archivos anteriores
					this.selectedFiles = [];
					this.filesWithSelectedPages = {};

					// Establecer el nuevo archivo como seleccionado
					this.selectedFiles.push(file);

					// Si hay páginas seleccionadas, establecerlas
					if (documentData.selectedPages) {
						this.filesWithSelectedPages[file.name] = documentData.selectedPages;
					}

					this.$emit("update:hasFiles", true);
					this.fileUploadComplete = true;

					// Asegurar que no se muestre la vista previa de páginas
					this.showPagesPreview = false;
				}
			} catch (error) {
				console.error('Error al cargar el documento:', error);
				this.$toast.error('Error al cargar el documento');
			}
		},
		toggleQuestionType(type) {
			const questionType = this.questionTypes.find(qt => qt.value === type);
			if (questionType.isPremiumType && !this.isPremium) {
				this.openFeaturesDialog('file_uploader_premium_question_type');
				return;
			}

			const index = this.selectedQuestionTypes.indexOf(type);
			if (index === -1) {
				this.selectedQuestionTypes.push(type);
			} else {
				this.selectedQuestionTypes.splice(index, 1);
			}
		},
		async loadSubjectInfo(subjectId) {
			try {
				const response = await this.axios.get(`/education/user-subjects/${subjectId}`, {
					headers: {
						Authorization: this.$root.token.value
					}
				});
				if (response.data) {
					this.selectedSubject = response.data;
				}
			} catch (err) {
				console.error('Error al cargar la información de la asignatura:', err);
			}
		},

		async loadSubjects() {
			try {
				const response = await this.axios.get('/education/user-subjects', {
					headers: {
						Authorization: this.$root.token.value
					}
				});
				if (response.data && Array.isArray(response.data)) {
					this.subjects = response.data;
				}
			} catch (err) {
				console.error('Error al cargar las asignaturas:', err);
			}
		},


		// + Métodos para manejar los eventos del resumen en streaming
		handleSummaryComplete() {
			console.log("Evento handleSummaryComplete recibido");
			this.isProcessingSummary = false; // El resumen ya no se está procesando
			this.showStreamingSummary = false; // Ocultar el componente de resumen
			if (this.summaryPromise && typeof this.summaryPromise.resolve === 'function') {
				this.summaryPromise.resolve(true); // Indicar éxito y continuar processFiles
			} else {
				console.warn("summaryPromise.resolve no es una función en handleSummaryComplete");
			}
			this.summaryPromise = null; // Limpiar la promesa
			console.log("Resumen completado, procediendo a generar contenido completo.");
		},
		handleSummaryError(errorMessage) {
			console.log("Evento handleSummaryError recibido", errorMessage);
			this.isProcessingSummary = false;
			this.showStreamingSummary = false;
			this.$toast.warning(errorMessage || "No se pudo generar el resumen.");
			if (this.summaryPromise && typeof this.summaryPromise.resolve === 'function') {
				this.summaryPromise.resolve(false); // Indicar fallo pero permitir continuar (o cambiar a true si queremos continuar siempre)
			} else {
				console.warn("summaryPromise.resolve no es una función en handleSummaryError");
			}
			this.summaryPromise = null;
		},
		handleSummarySkipped() {
			console.log("Evento handleSummarySkipped recibido");
			this.isProcessingSummary = false;
			this.showStreamingSummary = false;
			if (this.summaryPromise && typeof this.summaryPromise.resolve === 'function') {
				this.summaryPromise.resolve(false); // Tratar como no exitoso para el resumen, pero continuar
			} else {
				console.warn("summaryPromise.resolve no es una función en handleSummarySkipped");
			}
			this.summaryPromise = null;
			console.log("Resumen omitido, procediendo a generar contenido completo.");
		},
		hideSummary() {
			if (this.$refs.streamingSummaryComponent) {
				this.$refs.streamingSummaryComponent.hideContent();
			}
		},
		// + Nuevo método para generar la estructura del documento en streaming
		async fetchStreamingDocumentStructure() {
			if (!this.currentDocumentForSummary || !this.currentDocumentForSummary.id) {
				console.log("[DEBUG] No hay documento seleccionado para generar estructura");
				return null;
			}

			console.log("[DEBUG] Iniciando fetchStreamingDocumentStructure con:", {
				documentId: this.currentDocumentForSummary.id,
				language: this.detectedLanguage || 'auto'
			});

			this.isGeneratingStructure = true;
			this.structureComplete = false;
			this.documentStructure = null; // Resetear estructura previa

			try {
				console.log(`[DEBUG] Iniciando streaming de estructura para el documento ${this.currentDocumentForSummary.id}. Idioma: ${this.detectedLanguage || 'auto'}`);

				const backendUrl = process.env.VUE_APP_AXIOS_URI || '';
				const apiUrl = `${backendUrl}/generate-document-structure-stream`;
				console.log("[DEBUG] URL del endpoint:", apiUrl);

				const response = await fetch(apiUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'text/event-stream',
						Authorization: this.$root.token?.value || ''
					},
					body: JSON.stringify({
						documentId: this.currentDocumentForSummary.id,
						userId: this.$root.currentUser?.userId,
						language: this.detectedLanguage || 'auto'
					})
				});

				console.log("[DEBUG] Respuesta inicial recibida:", response.status, response.statusText);

				if (!response.ok) {
					let errorMsg = `Error HTTP: ${response.status} ${response.statusText}`;
					try {
						const errorBody = await response.json();
						errorMsg = errorBody.error || errorBody.message || errorMsg;
					} catch (e) { /* Ignorar si el cuerpo del error no es JSON */ }

					console.error("[DEBUG] Error en la respuesta inicial del streaming de estructura:", errorMsg);
					this.$toast.warning(`Error al iniciar la generación de estructura: ${errorMsg}`);
					this.structureComplete = true;
					return null;
				}

				if (!response.body) {
					console.error("[DEBUG] El cuerpo de la respuesta del stream es nulo.");
					this.structureComplete = true;
					return null;
				}

				return new Promise((resolve, reject) => {
					const reader = response.body.getReader();
					const decoder = new TextDecoder();
					let buffer = '';

					const processStream = async () => {
						try {
							let readCount = 0;
							while (true) {
								readCount++;
								// console.log(`[DEBUG] processStream: Attempting reader.read() - call #${readCount}`);
								const { done, value } = await reader.read();

								const decodedChunk = value ? decoder.decode(value, { stream: true }) : "";

								// console.log(`[DEBUG] processStream read #${readCount}: done=${done}, value.byteLength=${value?.byteLength || 0}, decodedChunk length=${decodedChunk.length}`);
								// if (decodedChunk.length > 0) {
								//     console.log(`[DEBUG] decodedChunk #${readCount} preview: '${decodedChunk.substring(0, 150)}'`);
								// }

								if (done) {
									console.log(`[DEBUG] FE: Stream ended by reader.done after ${readCount} reads. Final buffer content: '${buffer.substring(0, 300)}...'`);
									this.structureComplete = true;
									resolve(this.documentStructure);
									break;
								}

								buffer += decodedChunk;
								// console.log(`[DEBUG] FE: Buffer length after read #${readCount}: ${buffer.length}, buffer now starts with: '${buffer.substring(0,150)}'`);

								let eventBoundaryIndex;
								while ((eventBoundaryIndex = buffer.indexOf('\n\n')) !== -1) {
									const eventText = buffer.substring(0, eventBoundaryIndex);
									buffer = buffer.substring(eventBoundaryIndex + 2); // Consume the event and the delimiter

									console.log(`[DEBUG] FE: Extracted SSE Event block (approx ${eventText.length} chars): '${eventText.substring(0, 200)}...'`);

									let eventName = 'message';
									let eventDataAccumulator = '';
									const lines = eventText.split('\n');

									lines.forEach(line => {
										const trimmedLine = line.trim();
										if (trimmedLine.startsWith('event:')) {
											eventName = trimmedLine.substring(6).trim();
										} else if (trimmedLine.startsWith('data:')) {
											eventDataAccumulator += trimmedLine.substring(5).trim();
										}
									});

									console.log(`[DEBUG] FE: Processed Event Details: Name='${eventName}', Data (first 100 chars)='${eventDataAccumulator.substring(0, 100)}...'`);

									if (eventDataAccumulator) {
										try {
											const parsedSSEData = JSON.parse(eventDataAccumulator);
											console.log('[DEBUG] FE: Successfully parsed eventData. Type:', parsedSSEData.type);

											if (eventName === 'message' && parsedSSEData.type === 'structure_update' && parsedSSEData.data) {
												this.documentStructure = parsedSSEData.data;
												console.log("[DEBUG] FE: Applied 'structure_update'. documentStructure updated. Sections: ", this.documentStructure?.document_structure?.length || 0, "Name: ", this.documentStructure?.document_name);
											} else if (eventName === 'message' && parsedSSEData.type === 'info') {
												console.log("[DEBUG] FE: Info message from stream:", parsedSSEData.message);
											} else if (eventName === 'message' && parsedSSEData.type === 'raw_chunk') {
												// Actualizar documentStructure progresivamente con cada chunk
												if (parsedSSEData.text_chunk) {
													// Inicializar documentStructure si aún no existe
													if (!this.documentStructure) {
														this.documentStructure = {
															document_name: "Documento",
															document_structure: []
														};
													}

													// Actualizar acumulando el JSON parcial
													try {
														// Intentar construir un JSON válido agregando los chunks
														const accumulatedJson = parsedSSEData.text_chunk;

														console.log("[DEBUG] FE: Processing raw_chunk, text_chunk:", parsedSSEData.text_chunk.substring(0, 50));

														// Verificar si este fragmento contiene una sección completa o parte de una
														if (accumulatedJson.includes("section_name") && accumulatedJson.includes("section_unique_id")) {
															const sectionMatch = accumulatedJson.match(/\"section_name\"\s*:\s*\"([^\"]+)\"/);
															const idMatch = accumulatedJson.match(/\"section_unique_id\"\s*:\s*\"([^\"]+)\"/);

															if (sectionMatch && idMatch) {
																const sectionName = sectionMatch[1];
																const sectionId = idMatch[1];

																// Verificar si esta sección ya existe en document_structure
																const existingSection = this.documentStructure.document_structure.find(
																	s => s.section_unique_id === sectionId
																);

																if (!existingSection) {
																	// Añadir nueva sección
																	this.documentStructure.document_structure.push({
																		section_name: sectionName,
																		section_unique_id: sectionId,
																		subsections: []
																	});
																	console.log(`[DEBUG] FE: Added new section from chunk: ${sectionName} (${sectionId})`);
																}
															}
														}

														// Si parece contener el nombre del documento
														if (accumulatedJson.includes("document_name")) {
															const docNameMatch = accumulatedJson.match(/\"document_name\"\s*:\s*\"([^\"]+)\"/);
															if (docNameMatch) {
																this.documentStructure.document_name = docNameMatch[1];
																console.log(`[DEBUG] FE: Updated document_name from chunk: ${this.documentStructure.document_name}`);
															}
														}
													} catch (chunkParseError) {
														console.warn("[DEBUG] FE: Could not parse fragment as valid JSON:", chunkParseError);
													}
												}
											} else if (eventName === 'end' && parsedSSEData.final_structure) {
												this.documentStructure = parsedSSEData.final_structure;
												console.log("[DEBUG] FE: Applied 'final_structure' from 'end' event. documentStructure updated. Sections: ", this.documentStructure?.document_structure?.length || 0, "Name: ", this.documentStructure?.document_name);
												this.$toast.success(parsedSSEData.message || "Estructura del documento generada.");
												this.structureComplete = true;
											} else if (eventName === 'error_event') {
												console.error("[DEBUG] FE: Error event from stream:", parsedSSEData.error, parsedSSEData.details);
												this.$toast.error(`Error generando estructura: ${parsedSSEData.error || 'Error desconocido'}`);
											} else {
												console.log("[DEBUG] FE: Parsed event data, but no specific handler for eventName/type:", eventName, parsedSSEData.type);
											}
										} catch (e) {
											console.error("[DEBUG] FE: Error parsing eventData JSON:", e, "Raw eventDataAccumulator:", eventDataAccumulator);
										}
									} else {
										console.log("[DEBUG] FE: Extracted event block, but eventDataAccumulator is empty. EventName:", eventName);
									}
								}
							}
						} catch (error) {
							console.error("[DEBUG] FE: Error in processStream loop:", error);
							this.structureComplete = true;
							reject(error);
						}
					};

					processStream();
				});

			} catch (error) {
				console.error("[DEBUG] Error al iniciar el fetch para streaming de estructura:", error);
				this.$toast.error("No se pudo iniciar la generación de estructura del documento.");
				this.structureComplete = true;
				return null;
			}
		},
		async goToDocumentView() {
			await this.$refs.studyConfig.assignDocumentToSubject(this.selectedFiles[0].documentId);

			if (this.selectedFiles.length > 0 && this.selectedFiles[0].documentId) {
				this.$router.push(`/app/document/${this.selectedFiles[0].documentId}`);
			} else {
				this.$toast.error('Error: No hay archivo seleccionado o falta el ID del documento.');
			}
		},
		openFeaturesDialog(origin) {
			this.$router.push({ query: { ...this.$route.query, premium_from: origin } }).catch(err => {
				if (err.name !== 'NavigationDuplicated') {
					console.error(err);
				}
			});
			this.showFeaturesDialog = true;
		},
	},
	watch: {
		showFeaturesDialog(isShown) {
			if (!isShown && this.$route.query.premium_from) {
				const query = { ...this.$route.query };
				delete query.premium_from;
				this.$router.push({ query }).catch(err => {
					if (err.name !== 'NavigationDuplicated') {
						console.error(err);
					}
				});
			}
		},
		selectedPages(val) {
			if (val.length === this.documentPages.length) {
				this.selectAllPages = true
			} else {
				this.selectAllPages = false
			}
		},
		documentPages(val) {
			if (val.length === this.selectedPages.length) {
				this.selectAllPages = true
			} else {
				this.selectAllPages = false
			}
		},
		subjectId: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.loadSubjectInfo(newVal);
				}
			}
		}
	},
	beforeDestroy() {
		// - Eliminar
	}
}
</script>

<style scoped>
.upload-area {
	border: 1px dashed #4dd453;
	border-radius: 8px;
	text-align: center;
	cursor: pointer;
	transition: background-color 0.3s ease;
}

.upload-area:hover {
	background-color: rgba(76, 175, 80, 0.1);
}

.upload-area input[type="file"] {
	display: none;
}

.supported-files {
	margin-top: 10px;
	color: #616161;
	font-size: 0.9rem;
}

.selected-files-area {
	background-color: #fff;
	border-radius: 0px;
	padding: 16px;
}

.selected-files-list {
	list-style-type: none;
	padding-left: 0;
}


/* Estilos para los botones principales */
.v-btn.primary {
	text-transform: none !important;
	letter-spacing: 0 !important;
	font-weight: 800 !important;
	font-size: 1rem !important;
	border-radius: 10px !important;
	transition: filter 0.2s ease, transform 0.1s ease !important;
	border: 2px solid #4dd453 !important;
	height: 38px !important;
	padding-left: 24px !important;
	padding-right: 24px !important;
	background-color: #4dd453 !important;
	box-shadow: 0 4px 0 #58a700 !important;
	color: white;
}

.v-btn.primary:disabled {
	border: 2px solid #E0E0E0 !important;
	box-shadow: 0 4px 0 #9a9a9a !important;
}

.v-btn.primary:hover {
	filter: brightness(1.02);
	transform: translateY(0) !important;
}

.v-btn.primary:active {
	box-shadow: 0 0 0 #58a700 !important;
	transform: translateY(4px) !important;
}

.upload-card {
	width: 100%;
}

/* Estilos para la vista previa de páginas */
.pages-preview-container {
	width: 100%;
}

.pages-grid {
	overflow-y: auto;
	margin: 0;
	min-height: 320px;
	max-height: calc(100vh - 170px);
	background-color: #F9F9F9;
	opacity: 0.8;
	background-image: radial-gradient(#8cb785a9 0.8500000000000001px, #F9F9F9 0.8500000000000001px);
	background-size: 17px 17px;
	background-repeat: repeat;
	justify-content: center;
}

.page-card {
	cursor: pointer;
	transition: all 0.2s ease;
	border: 2px solid #e0e0e0;
	overflow: hidden;
	height: 100%;
	width: 100%;
	min-width: 100%;
	min-height: 100%;
	border-radius: 6px !important
}

.page-card.selected {
	border-color: #4dd453;
	background-color: rgba(77, 212, 83, 0.05);
}

.page-thumbnail {
	position: relative;
	width: 150px;
	height: 212px;
	min-width: 150px;
	min-height: 212px;
}

.page-number {
	display: flex;
	align-items: center;
	padding: 4px 8px;
	font-size: 0.8rem;
	color: #757575;
}

.selection-info {
	font-size: 0.9rem;
	color: #757575;
}

.v-chip-group>>>.v-chip.v-chip--outlined.v-chip.v-chip--outlined.theme--light.primary--text {
	border-color: #4dd453 !important;
	color: #4dd453 !important;
}

.canvas-container {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.canvas-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.preview-checkbox>>>.mdi-checkbox-marked {
	height: 15px;
	width: 15px;
	border-radius: 2px;
	background: white;
}

.preview-checkbox>>>i {
	height: 15px;
	width: 15px;
	border-radius: 2px;
	color: rgb(5, 15, 3);
}

.preview-checkbox>>>.v-input--selection-controls__ripple {
	margin-top: 2px;
	margin-left: 3px;
}

.thumbnail-container {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	background-color: #f5f5f5;
	border-radius: 8px;
}

.thumbnail-image {
	width: 100%;
	height: 100%;
	object-fit: contain;
	background-color: white;
	border-radius: 8px;
}

.page-range-input {
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif;
}

.page-range-input>>>.v-input__slot {
	min-height: 42px !important;
}

.page-range-input>>>.v-text-field__slot input {
	font-size: 14px;
}

.page-range-input>>>.v-text-field__slot {
	margin-top: 4px !important;
}

.select-all>>>label {
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
	padding-right: 6px;
}

/* Estilos para la vista de procesamiento con frases motivadoras */
.processing-overlay,
.processing-overlay-generating,
.processing-overlay-upload {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(255, 255, 255, 0.95);
	/* Ligera transparencia para ver el fondo */
	z-index: 100;
	display: flex;
	/* Añadido para centrar el contenido si no estaba ya */
	flex-direction: column;
	/* Añadido */
	align-items: center;
	/* Añadido */
	justify-content: center;
	/* Añadido */
	text-align: center;
	/* Añadido */
	padding: 20px;
	/* Añadido */
}

.pages-grid {
	gap: 16px;
	padding: 16px;
}



.recent-documents-scroll {
	position: relative;
	overflow-x: auto;
	overflow-y: hidden;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: none;
	-ms-overflow-style: none;
	padding-bottom: 8px;
}

.recent-documents-scroll::-webkit-scrollbar {
	display: none;
	/* Chrome, Safari and Opera */
}

.recent-documents-grid {
	display: flex;
	flex-wrap: nowrap;
	gap: 16px;
	padding: 4px;
}

.recent-document {
	transition: all 0.2s ease;
	background: white;
	border: 1px solid #e0e0e0;
	border-radius: 12px;
	max-width: 280px;
	padding-right: 16px !important;
	cursor: pointer;
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif !important;
}

.recent-document:hover {
	border-color: #4dd453;
}

.preview-container {
	width: 42px;
	height: 42px;
	min-width: 42px;
	border-radius: 8px;
	background: #f5f5f5;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
}

.preview-container img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.document-name {
	font-size: 0.9rem;
	font-weight: 500;
}

.question-type-card {
	background: white;
	border: 2px solid #e0e0e0;
	border-radius: 12px;
	padding: 16px;
	cursor: pointer;
	transition: all 0.2s ease;
	width: calc(33.33% - 11px);
	min-width: 180px;
	max-width: 250px;
	position: relative;
}

.question-type-card:hover {
	border-color: #4dd453;
	background-color: rgba(77, 212, 83, 0.05);
}

.question-type-card.selected {
	border-color: #4dd453;
	background-color: rgba(77, 212, 83, 0.05);
}

.premium-badge {
	position: absolute;
	op: 8px;
	right: 8px;
	background: #FFD700;
	color: #4c2200;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	font-weight: bold;
	text-transform: uppercase;
	display: flex;
	align-items: center;
	justify-content: center;
}

.v-autocomplete>>>.v-select__selection {
	margin-top: 2px;
}

.v-autocomplete>>>.v-input__slot {
	min-height: 42px !important;
}

.v-autocomplete>>>.v-text-field__slot input {
	font-size: 14px;
	font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
}

.v-autocomplete>>>.v-select__selections {
	padding-top: 2px;
}

/* + Estilos para el contenedor del preview del documento en la sección de configuración */
.document-preview-config {
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	padding: 12px;
	max-width: 350px;
	background-color: #fafafa;
	/* Un fondo ligero para distinguirlo */
}

/* + Estilos para los botones fijados en la parte inferior en la vista de configuración */
.fixed-bottom-actions {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: white;
	padding: 16px;
	border-top: 1px solid #E3E5EB;
	z-index: 10;
	/* Para asegurar que esté por encima de otros elementos */
}

/* + Estilos para el contenedor del resumen en streaming si es necesario */
.streaming-summary-wrapper {
	/* Puedes añadir estilos específicos para el contenedor del resumen aquí si es necesario */
	/* Por ejemplo, un borde o un fondo diferente mientras se carga. */
	/* El componente StreamingSummaryDisplay ya tiene su propio padding y borde */
}

/* + Estilos para los chips de estructura */
.structure-chips-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-bottom: 8px;
	background-color: rgba(255, 255, 255, 0.9);
	border-radius: 8px;
}

.structure-chip {
	margin: 4px;
	font-size: 12px;
	background-color: rgba(77, 212, 83, 0.1);
}

/* Estilos para las instrucciones visuales */
.instructions-section {
	background-color: rgba(248, 250, 252, 0.8);
	border-radius: 16px;
	padding: 24px 20px;
	margin: 0 auto;
}

.instructions-steps {
	gap: 12px;
}

.instruction-step {
	transition: transform 0.2s ease;
}

.instruction-step:hover {
	transform: translateY(-2px);
}

.step-icon {
	transition: all 0.3s ease;
}

.instruction-step:hover .step-icon {
	transform: scale(1.05);
	box-shadow: 0 4px 12px rgba(77, 212, 83, 0.2);
}

.step-title {
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif;
}

.step-description {
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif;
}

.step-number {
	font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, sans-serif;
	letter-spacing: 0.5px;
}

/* Responsive para móviles */
@media (max-width: 768px) {
	.instructions-steps {
		gap: 20px;
	}
	
	.instruction-step {
		margin: 8px 0 !important;
	}
}
</style>
